
import React, { useEffect, useState, useRef} from 'react';
import { Link } from 'react-router-dom';
import { nanoid } from 'nanoid';

import Image from '../../components/imageComponent';
import {useGetCategories} from '../../apiHooks/home';
import { arrRight } from '../../svgs';
import {  CategoryDropdown } from './styled';


export default function Filter( { open } ) {
  
  const {data, isLoading, isError} = useGetCategories();
  
  return (
   
    <CategoryDropdown open={open} >
      <div className="container">
        <div className='headline'>ყველა კატეგორია</div>

        {/*  category list */}
        {isLoading? "loading" : isError ? (
          <span>Error</span>
        ) : data.data.results.length ? (
          <div className="list" >
            {data.data.results.map((cat) => {
              return (
                <Link key={nanoid()} to={`/?category=${cat.slug || cat.name}`}  className="link" >
                  <div className="hero">
                    <Image src={cat.icon || cat.image || ''} contain objectFit="contain" layout="fill" />
                  </div>
                  <h4>{cat.name}</h4>
                  <span>{arrRight()}</span>
                </Link>
              );
            })}
          </div>
        ) : null}
      </div>
    </CategoryDropdown>
  )
}
